<template>
  <div
    class="flex items-center justify-between bg-neutral-secondary pt-2 w-full h-full relative"
  >
    <NTabs
      v-model="tab"
      class="w-full"
      content-class="overflow-hidden !h-[calc(100%-50px)]"
    >
      <div
        class="cursor-pointer rounded-full flex items-center justify-center bg-neutral-primary px-3 h-8 mr-2 hover:bg-transparent"
        @click.stop="emit('handlePortfolioVisualization')"
      >
        <NegarShrinkIcon size="20" class="ml-1" />

        <NText variant="caption1" weight="bold" class="text-neutral-secondary">
          {{ t('misc.close') }}
        </NText>
      </div>

      <div class="mx-4 border-r border-neutral-tertiary h-6 my-auto" />

      <PortfolioVisualizationTab />

      <VirtualPortfolioVisualizationTab />
    </NTabs>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { NegarShrinkIcon } from '@negar/icons';
import { PortfolioItem } from '@libs/api-reference';
import { useRoute } from 'vue-router';

import {
  PortfolioVisualizationTab,
  VirtualPortfolioVisualizationTab,
} from '@/modules/portfolio';

const emit = defineEmits<{
  (e?: 'handlePortfolioVisualization'): void;
}>();

defineProps<{
  portfolioSymbols: PortfolioItem[];
}>();

const route = useRoute();

const tab = ref(route.query.virtualPortfolio ? 1 : 0);

const { t } = useI18n();
</script>
